<template>
	<div class="o-dashboard">

		<c-tabs :tabs="tabs" @selectTab="setTab">

			<c-tab v-if="tab == 'deliveries'">
				<c-table
                    ref="table"
					:endpoint="'/api/deliveries'"
					:columns="columns"
					:placeholder="'Zoeken op ordernummer, adres, topdesknummer of eindklant'">
				</c-table>
			</c-tab>

			<c-tab v-if="tab == 'backorders'">
				<c-table
                    ref="table"
                    :endpoint="'/api/backorders'"
					:columns="columns"
					:placeholder="'Zoeken op ordernummer, adres, topdesknummer of eindklant'">
				</c-table>
			</c-tab>

			<c-tab v-if="tab == 'finishedDeliveries'">
				<c-table
                    ref="table"
                    :endpoint="'/api/finisheddeliveries'"
					:columns="columnsFinished"
					:placeholder="'Zoeken op ordernummer, adres, topdesknummer of eindklant'">
				</c-table>
			</c-tab>

            <c-tab v-if="tab == 'cancelledDeliveries'">
                <c-table
                    ref="table"
                    :endpoint="'/api/cancelleddeliveries'"
                    :columns="columns"
					:placeholder="'Zoeken op ordernummer, adres, topdesknummer of eindklant'">
                </c-table>
            </c-tab>

		</c-tabs>

	</div>
</template>

<script>
import View from '@mixins/View';
import CTable from '@components/table/Table';
import CTabs from '@components/tab/Container';
import CTab from '@components/tab/Element';
export default {
	mixins: [ View],
	components: { CTable, CTabs, CTab },
	data()
	{
		return {
			tabs: [
				{ name:'deliveries', label: 'Leveringen' },
				{ name:'backorders', label: 'Backorders' },
				{ name:'finishedDeliveries', label: 'Afgerond' },
				{ name:'cancelledDeliveries', label: 'Geannuleerd' },
			]
		}
	},
	methods: {
		setTab(tab) {
			this.tab = tab;
		},
        exportDelivery() {
            const link = document.createElement('a');
            link.href = '/api/exportdelivery?search=' + this.$refs.table.selection.search.all + '&sort=' + this.$refs.table.sort.column + '&order=' + this.$refs.table.sort.direction + '&tab=' + this.tab;
            document.body.appendChild(link);
            link.click();
        }
	},
	computed: {
		columns() {
			return [
				{ name: 'date', component: 'CColumnDatetime', label: 'Datum', sortable: true, sort: true },
				{ name: 'order_number', label: 'Ordernummer', sortable: true },
				{ name: 'endclientName', label: 'Eindklant', sortable: true, sortField: 'client.parent.name,client.name'},
				{ name: 'address.street,address.number,address.addition,address.zipcode,address.city', label: 'Adres', sortable: true, sortField: 'address' },
				{ name: 'delivery_type.name', label: 'Type', sortable: true },
				{ name: 'products.length', label: 'Voorraad'},
                { name: 'created_at', component:  'CColumnDateWithHours', label: 'Aanmelddatum', sortable: true },
				{ name: 'w_number', label: 'Topdesknummer', sortable: true },
                { name: "id", label: '', component: 'CColumnButton', props: { route: 'deliveryDetail' }},
			];
		},
		columnsFinished() {
			return [
				{ name: 'date', component: 'CColumnDatetime', label: 'Datum', sortable: true, sort: true },
				{ name: 'order_number', label: 'Ordernummer', sortable: true },
				{ name: 'endclientName', label: 'Eindklant', sortable: true, sortField: 'client.name'},
				{ name: 'address.street,address.number,address.addition,address.zipcode,address.city', label: 'Adres', sortable: true, sortField: 'address' },
				{ name: 'delivery_type.name', label: 'Type', sortable: true },
				{ name: 'products.length', label: 'Voorraad'},
                { name: 'created_at', component:  'CColumnDateWithHours', label: 'Aanmelddatum', sortable: true },
                { name: 'completed', component: 'CColumnDateWithHours', label: 'Afgerond op', sortable: true },
				{ name: 'w_number', label: 'Topdesknummer', sortable: true },
				{ name: "id", label: '', component: 'CColumnButton', props: { route: 'deliveryDetail' }},
			];

		},
	},
    beforeUnmount(){
        this.$store.dispatch('listener/off', {
            event: 'exportDelivery',
            listener: this.exportDelivery
        });
    },
    created(){
        this.$store.dispatch('listener/on', {
            event: 'exportDelivery',
            listener: this.exportDelivery
        });
    },
}
</script>
